import create from "zustand";

const useUserDataStore = create((set: any) => ({
    user: {},
    setUser: (data: object) => set(() => ({ user: data })),
}));

export { useUserDataStore };
